import * as React from "react";
import { useEffect } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getApiCall } from "services/apiHelper";
import { baseUrl } from "config/config";
import { updatePrioritiesTab } from "redux/slices/updateDataSlice";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

export function PrioritiesDisplayForm() {
  const dispatch = useAppDispatch();
  const assetPlanId = useAppSelector((state) => state.getAssetPlanId.assetPlanId);
  const prioritiesData = useAppSelector((state) => state.updateData?.prioritiesTab);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getApiCall(`${baseUrl}AssetPlan/GetPrioritiesDetailsByAssetID?assetPlanId=${assetPlanId}`);
        dispatch(updatePrioritiesTab(response as any));
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };
    
    if (assetPlanId) fetchData();
  }, [assetPlanId, dispatch]);

  return (
    <div>
      <div className="tab-heading text-center">
        <h3 className="heading">Priorities</h3>
      </div>

      <h3 className="text-left sub-heading">Key Objectives</h3>

      <Box sx={{ flexGrow: 1 }} className="summary-form m-20">
        <Grid container spacing={2}>
          {loading ? (
            <Skeleton variant="rounded" width="100%" height={300} animation="wave" />
          ) : (
            <>
              <Grid item xs={12} md={4}>
                <Item>
                  <h3 className="text-left">Asset Management</h3>
                  <div className="grid-item-box">
                    <FroalaEditorView model={prioritiesData?.assetManagement || ''} />
                  </div>
                </Item>
              </Grid>

              <Grid item xs={12} md={4}>
                <Item>
                  <h3 className="text-left">Leasing</h3>
                  <div className="grid-item-box">
                    <FroalaEditorView model={prioritiesData?.leasing || ''} />
                  </div>
                </Item>
              </Grid>

              <Grid item xs={12} md={4}>
                <Item>
                  <h3 className="text-left">Building</h3>
                  <div className="grid-item-box">
                    <FroalaEditorView model={prioritiesData?.building || ''} />
                  </div>
                </Item>
              </Grid>

              <Grid item xs={12} md={4}>
                <Item>
                  <h3 className="text-left">Sustainability</h3>
                  <div className="grid-item-box">
                    <FroalaEditorView model={prioritiesData?.sustainability || ''} />
                  </div>
                </Item>
              </Grid>

              <Grid item xs={12} md={4}>
                <Item>
                  <h3 className="text-left">Social</h3>
                  <div className="grid-item-box">
                    <FroalaEditorView model={prioritiesData?.social || ''} />
                  </div>
                </Item>
              </Grid>

              <Grid item xs={12} md={4}>
                <Item>
                  <h3 className="text-left">Other</h3>
                  <div className="grid-item-box">
                    <FroalaEditorView model={prioritiesData?.other || ''} />
                  </div>
                </Item>
              </Grid>
            </>
          )}
        </Grid>
      </Box>

      <h3 className="text-left sub-heading">Leasing Summary</h3>

      <Box sx={{ flexGrow: 1 }} className="summary-form m-20">
        <Grid container spacing={2}>
          {loading ? (
            <Skeleton variant="rounded" width="100%" height={200} animation="wave" />
          ) : (
            <>
              <Grid item xs={12} md={4}>
                <Item>
                  <h3 className="text-left">Breaks / Expiries</h3>
                  <div className="grid-item-box">
                    <FroalaEditorView model={prioritiesData?.breaksExpiries || ''} />
                  </div>
                </Item>
              </Grid>

              <Grid item xs={12} md={4}>
                <Item>
                  <h3 className="text-left">Regears</h3>
                  <div className="grid-item-box">
                    <FroalaEditorView model={prioritiesData?.regears || ''} />
                  </div>
                </Item>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </div>
  );
}
